// @flow
import React from 'react';

import './DashboardLoadingPlaceholder.scss';

type Props = {
  type: string,
  className: string,
};

const DashboardLoadingPlaceholder = ({ type, className }: Props) => {
  if (type === 'single') {
    return (
      <div className={`dashboard-loading-placeholder -single ${className}`}>
        <div className="dashboard-loading-placeholder__bar" />
      </div>
    );
  }

  if (type === 'dot-dash') {
    return (
      <div className={`dashboard-loading-placeholder -dot-dash ${className}`}>
        <div className="dashboard-loading-placeholder__bar -dot" />
        <div className="dashboard-loading-placeholder__bar -dash" />
      </div>
    );
  }

  return (
    <div className={`dashboard-loading-placeholder -triple ${className}`}>
      <div className="dashboard-loading-placeholder__bar" />
      <div className="dashboard-loading-placeholder__bar" />
      <div className="dashboard-loading-placeholder__bar" />
    </div>
  );
};

DashboardLoadingPlaceholder.displayName = 'DashboardLoadingPlaceholder';

export default DashboardLoadingPlaceholder;
